// import { Routes, Route, Link } from 'react-router-dom';
import { strToolNameHeadline, default_tooltip_show, default_tooltip_hide } from '../Consts';
import React from 'react';

import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// import { openNewTabWithChecklist } from '../Functions';
import StatusBlock from '../StatusBlock/StatusBlock';

import './NavbarTop.css';

// export function NavbarTop() {
const NavbarTop = ({ parentState, backCallerHandleToggleOffCanvas, backCallerHandlePrint,
    backCallerGoModal, backCallerHandleToggleTooltips }) => {


    function handleClick() {
        var wrapper = document.querySelector('.move-right');
        var toggleIconDiv = document.getElementById('toggle-icon-div');

        backCallerHandleToggleOffCanvas();

        if (!parentState.helper.offcanvas.show) {
            wrapper.classList.add('offcanvas-open');
            setTimeout(function () {
                toggleIconDiv.classList.remove('oc-close');
                toggleIconDiv.classList.add('oc-open');
            }, 50);
        } else {
            wrapper.classList.remove('offcanvas-open');
            setTimeout(function () {
                toggleIconDiv.classList.remove('oc-open');
                toggleIconDiv.classList.add('oc-close');
            }, 50);
        }
    }

    const renderTooltip = ({ message, className }) => (
        <Tooltip id="tooltip" className={`${className} no-print`}>
            {message}</Tooltip>
    );

    return (
        <>
            <nav className="navbar navbar-light bg-light fixed-top p-1 border-bottom">
                <div className="container-fluid pe-0">
                    <div className="flex-container">

                        <div id="toggle-icon-div" className="me-2 oc-open no-print">
                            <Button id="toggle-icon-button" className="navbar-toggler p-0 px-2" type="button"
                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
                                aria-controls="offcanvasNavbar"
                                onClick={handleClick}>
                                <span id="toggle-icon-button-span"
                                    className="fw-bold navbar-toggler-icon navbar-toggle-icon-black"></span>
                            </Button>
                        </div>

                        <div className="me-2">
                            <Link to="/erfassung">
                                <img id="headerImageLion" src={`${process.env.PUBLIC_URL}/bw.svg`} alt="Baden-Württemberg"
                                    title="Baden-Württemberg" />
                            </Link>
                        </div>

                        <div className="fw-bold nowrap-text flex-grow-1">
                            {strToolNameHeadline}
                        </div>

                        <div className="me-2">
                            <Button onClick={() => backCallerHandleToggleTooltips()}
                                variant="outline-light" className="px-0">
                                <OverlayTrigger placement="bottom-start"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={renderTooltip({
                                        message: parentState.helper.tooltips
                                            ? "Tooltips deaktivieren"
                                            : "Tooltips aktivieren",
                                        className: "custom-tooltip"
                                    })}
                                >
                                    {/* {parentState.helper.tooltips ? (
                                        <i className="bi bi-question-circle-fill" />
                                    ) : (
                                        <i className="bi bi-question-circle" />
                                    )} */}
                                    {parentState.helper.tooltips ? (
                                        <i className="bi bi-toggle-on"></i>
                                    ) : (
                                        <i className="bi bi-toggle-off"></i>
                                    )}
                                </OverlayTrigger>
                            </Button>
                        </div>

                        <div className="me-2">
                            <Button
                                variant="outline-light" className="px-0">
                                <OverlayTrigger
                                    placement="bottom-start"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={
                                        <Tooltip className="custom-tooltip">
                                            <StatusBlock parentState={parentState} size="small" />
                                        </Tooltip>
                                    }
                                    show={parentState.helper.tooltips ? undefined : false}
                                >
                                    <i className="bi bi-info-circle"></i>
                                </OverlayTrigger>
                            </Button>
                        </div>

                        <div className="me-2">
                            <Button onClick={() => backCallerHandlePrint()}
                                variant="outline-light" className="px-0">
                                <OverlayTrigger placement="bottom-start"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={renderTooltip({
                                        message: "Einen Druckvorgang beginnen",
                                        className: "custom-tooltip"
                                    })}
                                    show={parentState.helper.tooltips ? undefined : false}
                                >
                                    <i className="bi bi-printer"></i>
                                </OverlayTrigger>
                            </Button>
                        </div>

                        <div className="me-2">
                            <Button onClick={() => backCallerGoModal('reset')}
                                variant="outline-light" className="px-0 me-0">
                                <OverlayTrigger placement="bottom-start"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={renderTooltip({
                                        message: "Werkzeug zurücksetzen",
                                        className: "custom-tooltip"
                                    })}
                                    show={parentState.helper.tooltips ? undefined : false}
                                >
                                    {/* <i className="bi bi-arrow-counterclockwise"></i>
                                        <i className="bi bi-arrow-clockwise"></i>
                                        <i className="bi bi-arrow-repeat"></i>
                                        <i className="bi bi-bootstrap-reboot"></i> */}
                                    <i className="bi bi-x-octagon reset-icon" aria-label="Werkzeug zurücksetzen"></i>

                                </OverlayTrigger>
                            </Button>
                        </div>

                    </div>
                </div>
            </nav>
        </>
    )
}

export default NavbarTop;